// components/common/AvatarWithInitials.tsx
import React, { useEffect, useState } from "react";
import { getColorFromName, getInitials } from "../../helper/avatarHelper";
import { getUserImages } from "../../services/attendanceService";

interface AvatarWithInitialsProps {
  id?: any;
  name?: string;
  role?: string;
  size?: "sm" | "md" | "lg";
  showName?: boolean;
  showRole?: boolean; // NEW: to toggle role from full user object
  className?: string;
}

const DefaultImageHandler: React.FC<AvatarWithInitialsProps> = ({
  name,
  role,
  size = "md",
  showName = true,
  showRole = false,
  className = "",
  id,
}) => {
  const initials = getInitials(name);
  const bgColor = getColorFromName(name);
  const [userData, setUserData] = useState<any | null>(null);

  const avatarSizes = {
    sm: { width: "40px", height: "40px", fontSize: "0.75rem" },
    md: { width: "52px", height: "52px", fontSize: "0.875rem" },
    lg: { width: "70px", height: "70px", fontSize: "1rem" },
  };

  const selectedSize = avatarSizes[size] || avatarSizes["md"];

  useEffect(() => {
    const fetchUserData = async () => {
      if (!id) return;
      try {
        const user = await getUserImages(id);
        if (user) {
          setUserData(user);
        }
      } catch (error) {
        console.error("Error fetching user info:", error);
      }
    };

    fetchUserData();
  }, [id]);

  const imageUrl = userData?.Image || null;
  const userRole = showRole ? userData?.Department : role;
  return (
    <div className={`d-flex align-items-center ${className}`}>
      <div
        className="border avatar-rounded position-relative overflow-hidden"
        style={{
          width: selectedSize.width,
          height: selectedSize.height,
          borderRadius: "50%",
          position: "relative",
        }}
      >
        <div
          className="d-flex align-items-center justify-content-center w-100 h-100"
          style={{
            backgroundColor: bgColor,
            color: "white",
            fontSize: selectedSize.fontSize,
            fontWeight: 600,
            borderRadius: "inherit",
            width: "100%",
            height: "100%",
          }}
        >
          {initials}
        </div>
        {imageUrl && (
          <img
            src={imageUrl}
            alt={name}
            className="position-absolute top-0 start-0 object-fit-cover"
            style={{
              width: "100%",
              height: "100%",
              borderRadius: "inherit",
              objectFit: "cover",
            }}
          />
        )}
      </div>
      {showName && (
        <div className="ms-2">
          <h6 className="fw-medium mb-0">{name}</h6>
          {userRole && <span className="fs-12 fw-normal">{userRole}</span>}
        </div>
      )}
    </div>
  );
};

export default DefaultImageHandler
